import {Component, Input, OnInit} from '@angular/core';
import {Address} from '../../models/address';
import {Router} from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tw-address-view',
    templateUrl: './address-view.component.html',
    styleUrls: ['./address-view.component.css'],
    imports: [TranslatePipe]
})
export class AddressViewComponent implements OnInit {
    address: Address

    @Input() set addAddress(address: Address) {
        this.address = address
    };

    isCheckoutPage = false;

    constructor(private router: Router) {
    }

    ngOnInit() {
        this.isCheckoutPage = this.router.url.search('mode') !== -1 || this.router.url.search('checkout') !== -1;

    }

}
